export const cropColorMap : Record<string,string>= {
  'corn': '#FFD400',
  'soybeans': '#267300',
  'non cultivated': '#C7D79E',
  'cotton': '#FF2626',
  'winter wheat': '#A87000',
  'winter.wheat': '#10990b',
  'winter_wheat': '#10990b',
  'spring wheat': '#D9B56C',
  'other cultivate': '#FF6666',
  'other grains': '#D69DBC',
  'camelina': '#00AF4D',
  'sugarbeets': '#A900E6',
  'double crop': '#8A6453',
  'canola': '#D1FF00',
  'sugarcane': '#B380FF',
  'pasture': '#E9FFBE',
  'sunflower': '#FFFF00', // Couleur originale de la liste
  'rice': '#00A9E6',
  '2nd corn': '#FFB428',
  'soybean_corn': '#6E7800',
  'spring barley': '#FA4696',
  'winter barley': '#E2007F',
  'rapeseed': '#D1FF96',
  'other': '#FFFFFF',
  // ADDED BY JCT
  'barley':'#FA4696',
  'other_veg': '#333',
    'others': '#333',
};